import ReleaseCard from "./ReleaseCard";
import { Reveal } from "./Reveal";

export default function SectionGrid({ id, overline, title, releases, testId }) {
  if (!releases || releases.length === 0) return null;
  return (
    <section id={id} data-testid={testId} className="px-6 py-16 sm:px-10 sm:py-24 lg:px-16">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <p className="mb-2 text-xs font-bold uppercase tracking-[0.3em] text-gold">{overline}</p>
          <h2 className="mb-10 font-display text-3xl font-bold uppercase tracking-tight text-white sm:text-5xl">
            {title}
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {releases.map((r, i) => (
            <ReleaseCard key={r.internalId} release={r} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
